import axios from 'axios';

const NetworksAPI = {
  /**
   * Get networks for an organization
   * @param {number} organizationId - Organization ID
   * @param {Object} params - Query parameters (page, limit, sort, dir)
   * @returns {Promise}
   */
  getNetworks(organizationId, params = {}) {
    return axios.get(`/organizations/${organizationId}/networks`, { params }).then((response) => {
      return response.data;
    });
  },
};

export default NetworksAPI;
